import React from 'react';

const LABELS: Record<string, string> = {
  PENDING: 'Ausstehend',
  DEPLOYING: 'Wird bereitgestellt',
  ACTIVE: 'Aktiv',
  UPGRADING: 'Upgrade läuft',
  DOWNGRADING: 'Downgrade läuft',
  SUSPENDED: 'Pausiert',
  CANCELLATION_SCHEDULED: 'Gekündigt',
  TERMINATED: 'Beendet',
  DELETING: 'Wird gelöscht',
  DELETED: 'Gelöscht',
  FAILED: 'Fehler',
  PENDING_PAYMENT: 'Zahlung ausstehend',
  PAID: 'Bezahlt',
  PROVISIONING: 'Wird eingerichtet',
  CANCELLED: 'Storniert',
  SCHEDULED: 'Geplant',
  COMPLETED: 'Abgeschlossen',
};

const STYLES: Record<string, string> = {
  ACTIVE: 'bg-green-50 text-green-700 border-green-200',
  PAID: 'bg-green-50 text-green-700 border-green-200',
  COMPLETED: 'bg-green-50 text-green-700 border-green-200',
  PENDING: 'bg-slate-50 text-slate-600 border-slate-200',
  PENDING_PAYMENT: 'bg-amber-50 text-amber-700 border-amber-200',
  DEPLOYING: 'bg-blue-50 text-blue-700 border-blue-200',
  PROVISIONING: 'bg-blue-50 text-blue-700 border-blue-200',
  UPGRADING: 'bg-blue-50 text-blue-700 border-blue-200',
  DOWNGRADING: 'bg-blue-50 text-blue-700 border-blue-200',
  SUSPENDED: 'bg-amber-50 text-amber-700 border-amber-200',
  CANCELLATION_SCHEDULED: 'bg-amber-50 text-amber-700 border-amber-200',
  SCHEDULED: 'bg-amber-50 text-amber-700 border-amber-200',
  TERMINATED: 'bg-slate-100 text-slate-600 border-slate-200',
  DELETED: 'bg-slate-100 text-slate-600 border-slate-200',
  CANCELLED: 'bg-slate-100 text-slate-600 border-slate-200',
  FAILED: 'bg-red-50 text-red-700 border-red-200',
};

export default function StatusBadge({ status }: { status: string }) {
  return (
    <span
      className={`inline-block text-xs font-medium px-2 py-0.5 rounded-full border ${
        STYLES[status] ?? 'bg-slate-50 text-slate-600 border-slate-200'
      }`}
    >
      {LABELS[status] ?? status}
    </span>
  );
}
